import { useQuery, useQueryClient } from '@tanstack/react-query';
import useAdminAPIService from "@hooks/useAdminAPIService";
import { Stallholder } from "@sharedtypes/Stallholder";
import log from "loglevel";

const useAllStallholders = () => {
  const apiService = useAdminAPIService();

  return useQuery({
    queryKey: ['allStallholders'],
    queryFn: () =>
      apiService.fetch("getStallholders", {})
        .then((data: Stallholder[]) => {
          log.debug("All stallholders fetched", data);

          const sorted = [...data].sort((a, b) => {
            const n1 = parseInt(a.dealer_id);
            const n2 = parseInt(b.dealer_id);
            return n1 - n2;
          });

          return sorted;
        })
        .catch((error) => {
          log.error("fetch error:", error);
          return [] as Stallholder[];
        }),
    staleTime: Infinity,
    refetchInterval: 6000000,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};

export default useAllStallholders;
